import { Heading, Text } from '@cinch-labs/design-system'
import {
  VapsHero as VapsHeroProps,
  storyblokEditable,
} from '@cinch-nx/data-storyblok'
import { Wrapper } from '@cinch-nx/shared-ui'
import Image from 'next/legacy/image'
import {
  CinchChargeLogo,
  CinchCoverColourLogo,
  CinchCoverWhiteLogo,
  CinchShieldLogo,
  CinchServicingWhiteLogo,
} from './assets'
import styles from './vaps-hero.module.css'
import { useViewport } from '@cinch-labs/shared-util'

export const VapsHero: React.FC<VapsHeroProps> = (blok) => {
  const { title, body, image, logo } = blok

  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })
  const isMobile = vw < 1024

  const logoHeight = isMobile ? '28' : '39'
  const logoWidth = isMobile ? '142' : '197'
  return (
    <Wrapper
      {...storyblokEditable(blok)}
      isSlim
      className={{ inner: styles['root'] }}
    >
      {image?.filename && (
        <div className={styles['imageWrapper']}>
          <Image
            src={image?.filename}
            alt={image?.alt ?? undefined}
            layout="fill"
            objectFit="contain"
            priority
          />
        </div>
      )}
      <div className={styles['heroContent']}>
        {logo === 'cinchShield' && (
          <CinchShieldLogo
            className={styles.logo}
            data-testid="cinch-shield-logo"
            height={logoHeight}
            width={logoWidth}
          />
        )}
        {logo === 'cinchCharge' && (
          <CinchChargeLogo
            className={styles.logo}
            data-testid="cinch-charge-logo"
            height={logoHeight}
            width={logoWidth}
          />
        )}
        {logo === 'cinchCoverColour' && (
          <CinchCoverColourLogo
            className={styles.logo}
            data-testid="cinch-cover-colour-logo"
            height={logoHeight}
            width={logoWidth}
          />
        )}
        {logo === 'cinchCoverWhite' && (
          <CinchCoverWhiteLogo
            className={styles.logo}
            data-testid="cinch-cover-white-logo"
            height={logoHeight}
            width={logoWidth}
          />
        )}
        {logo === 'cinchServicingWhite' && (
          <CinchServicingWhiteLogo
            className={styles.logo}
            data-testid="cinch-servicing-white-logo"
            height={logoHeight}
            width={logoWidth}
          />
        )}
        <Heading element="h1" className={styles['title']}>
          {title}
        </Heading>
        <Text element="h2" className={styles['body']}>
          {body}
        </Text>
      </div>
    </Wrapper>
  )
}

export default VapsHero
